module.exports = __webpack_public_path__ + "img/105-Sheffield Oak Grey.jpg";